import { firebase } from '@/plugins/firebase';
import * as doronServices from '@/services/doronServices';
import * as authServices from '@/services/authServices';
import { payjp } from '@/utils/payjp';

const functions = firebase.app().functions('asia-northeast1');

export default {
  namespaced: true,
  state: {
    initialized: false,
    amount: 0,
    freeAmount: 0,
    unUsedDoron: [],
    unUsedFreeDoron: [],
    usedDoron: [],
    usedFreeDoron: []
  },
  mutations: {
    updateDoronDoc(state, payload) {
      if (!payload) return;
      state.amount = payload.amount;
      state.freeAmount = payload.freeAmount;
      state.unUsedDoron = payload.unUsedDoron;
      state.unUsedFreeDoron = payload.unUsedFreeDoron;
      state.usedDoron = payload.usedDoron;
      state.usedFreeDoron = payload.usedFreeDoron;
    },
    updateAmount(state, amount) {
      state.amount = amount;
    },
    updateFreeAmount(state, freeAmount) {
      state.freeAmount = freeAmount;
    },
    updateUnUsedDoron(state, unUsedDoron) {
      state.unUsedDoron = unUsedDoron;
    },
    updateUnusedFreeDoron(state, unUsedFreeDoron) {
      state.unUsedFreeDoron = unUsedFreeDoron;
    },
    addUsedDorons(state, usedDorons) {
      state.usedDoron = usedDorons;
    },
    addUsedFreeDorons(state, usedFreeDorons) {
      state.usedFreeDoron = usedFreeDorons;
    }
  },
  actions: {
    async loadDoronDoc({ commit }, userId) {
      const doronDoc = await doronServices.getDoronDoc(userId);
      commit('updateDoronDoc', doronDoc);
    },
    async purchaseDoron({ commit, state }, payload) {
      const createChargeMethod = functions.httpsCallable('paymentCreateCharge');
      const tdsFinishMethod = functions.httpsCallable('paymentTdsFinish');

      try {
        // create Charge on PAY.jp
        let params = {
          userId: payload.userId,
          cardId: payload.cardId,
          amount: payload.price,
          description: payload.amount + "ゴールド購入",
//          product: data.product,
        }
        const charge = await createChargeMethod(params);
        const chargeID = charge.data.id;
        await payjp.openThreeDSecureDialog(chargeID);
        const confirm = await tdsFinishMethod(chargeID);

        if (!confirm.data.captured) {
          return false;
        }

        // TODO: use batch to make sure things go right
        // create unused Doron
        await doronServices.addUnusedDoronDoc(payload.userId, {
          amount: Number(payload.amount),
          freeAmount: Number(payload.freeAmount),
          created: charge.data.created
        });
        // update doron db
        const result = await doronServices.updateDoronDoc(payload.userId, {
          amount: Number(state.amount) + Number(payload.amount),
          freeAmount: Number(state.freeAmount) + Number(payload.freeAmount)
        });

        // commit state
        commit('updateDoronDoc', result);

        return true;
      } catch (err) {
        return false;
      }
    },
    async purchaseItem({ commit, state }, gift) {
      if (gift.doronType == 'freeDoron') {
        const result = calculateDoronExpense(gift.price, state.unUsedFreeDoron);

        // update db
        await doronServices.updateDoronDoc(authServices.getUID(), {
          freeAmount: result.amount,
          unUsedFreeDoron: result.unUsedDoron
        });
        await doronServices.addUsedDoronDoc(authServices.getUID(), {
          usedDoronArray: [],
          usedFreeDoronArray: result.usedDoron
        });
        // commit
        commit('updateUnusedFreeDoron', result.unUsedDoron);
        commit('addUsedFreeDorons', result.usedDoron);
        commit('updateFreeAmount', result.amount);
      } else {
        const result = calculateDoronExpense(gift.price, state.unUsedDoron);
        // update db
        await doronServices.updateDoronDoc(authServices.getUID(), {
          amount: result.amount,
          unUsedDoron: result.unUsedDoron
        });
        await doronServices.addUsedDoronDoc(authServices.getUID(), {
          usedDoronArray: result.usedDoron,
          usedFreeDoronArray: []
        });
        // commit
        commit('updateUnUsedDoron', result.unUsedDoron);
        commit('addUsedDorons', result.usedDoron);
        commit('updateAmount', result.amount);
      }
    },
    async purchaseByCast({ commit }, payload) { // eslint-disable-line no-unused-vars
      const doronDoc = await doronServices.getDoronDoc(payload.userId);
      if (!doronDoc) {
        return;
      }
      const result = calculateDoronExpense(payload.price, doronDoc.unUsedDoron);

      await doronServices.updateDoronDoc(payload.userId, {
        amount: result.amount,
        unUsedDoron: result.unUsedDoron
      });
      await doronServices.addUsedDoronDoc(payload.userId, {
        usedDoronArray: result.usedDoron,
        usedFreeDoronArray: []
      });
      // commit
      commit('updateUnUsedDoron', result.unUsedDoron);
      commit('addUsedDorons', result.usedDoron);
      commit('updateAmount', result.amount);
    },
  },
  getters: {
    doronAmount(state) {
      return state.amount;
    },
    freeDoronAmount(state) {
      return state.freeAmount;
    }
  }
};

// helper functions
/*
Example:
  Input:
    unUsedDoron = [10, 20, 30, 10]
    purchaseAmount = [15]

  Output:
    unpusedDoron = [15, 30, 10]
    usedDoron = [10]
*/
function calculateDoronExpense(purchaseAmount, unUsedDoron) {
  var newUnUsedDoron = [];
  var newUsedDoron = [];
  var calcPurchaseAmount = purchaseAmount;

  unUsedDoron.forEach(item => {
    var d = JSON.parse(JSON.stringify(item));
    if (calcPurchaseAmount == 0) {
      newUnUsedDoron.push(d);
      return;
    }
    if (calcPurchaseAmount < d.remain) {
      d.remain = d.remain - calcPurchaseAmount;
      newUnUsedDoron.push(d);
      calcPurchaseAmount = 0;
    } else {
      calcPurchaseAmount = calcPurchaseAmount - d.remain;
      d.remain = 0;
      newUsedDoron.push(d);
    }
    return;
  });

  return {
    unUsedDoron: newUnUsedDoron,
    usedDoron: newUsedDoron,
    amount: newUnUsedDoron.length > 0 ? newUnUsedDoron.map(nd => nd.remain).reduce((acc, cur) => acc + cur) : 0
  };
}
